import { styled } from '@mui/material/styles';
import { Add, FilterAlt, FormatListBulleted, GridViewRounded } from "@mui/icons-material";
import { Button, ButtonBase, Grid, ListItemIcon, MenuItem, Pagination, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import BgBox from "../../../components/BgBox";
import CustReqCard from "../../../components/CustReqCard";
import CustReqTable from "../../../components/CustReqTable";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import { getAllCustReqWPagSrch } from "../../../services/req_service";
import { FaSortAmountDownAlt, FaSortAmountDown } from 'react-icons/fa';
import CustomDropDown from '../../../components/CustomDropDown';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import route from '../../../Routes';
import { useTranslation } from "react-i18next";
import QueryKey from '../../../QueryKey';
import { useQuery } from 'react-query';
import LoadingScreen from '../../../components/loadingScreen';
import MissingPage from '../../MissingPage';
import { ArrowDropDown, ArrowDropUp, Description, PictureAsPdf } from '@mui/icons-material';
import { useAuthContext } from '../../../context/AuthContext';
import { genCustReqRept } from '../../../services/pdf-service';
import { custReqExel } from '../../../services/excel-service';
import OptionMenu from '../../../components/OptionMenu';
import SearchTxtFieldClr from '../../../components/SearchTxtFieldClr';
import FilterMdl from './FilterMdl';
import { datePickerformat } from '../../../utils/format';
import { DEFAULT_PAGE_SIZE } from '../../../constants/pagination';
import RecordCount from "../../../components/RecordCount";
import { getAllReportConfigs } from '../../../services/bo-service';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    // margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

function CustReqListPage() {
  const { t } = useTranslation();
  const { time } = useParams();
  const ddArr = [
    { value: "invoice", label: t("bo.cusReqLstPg.dInvoice") },
    { value: "ewb", label: t("bo.cusReqLstPg.dEwb") },
    { value: "name", label: t("bo.cusReqLstPg.dCus") },
    { value: "reqId", label: t("bo.cusReqLstPg.dReqId") },
    { value: "mobile", label: t("bo.cusReqLstPg.dContact") },
    { value: "from", label: t("bo.cusReqLstPg.dFrom") },
    { value: "to", label: t("bo.cusReqLstPg.dTo") },
    { value: "fromto", label: t("bo.cusReqLstPg.dFromTo") },
    { value: "loadType", label: t("bo.cusReqLstPg.dLoadType") },
    { value: "matType", label: t("bo.cusReqLstPg.dMat") },
    { value: "shipmtId", label: t("bo.cusReqLstPg.dShipId") },
    { value: "cnor", label: t("bo.cusReqLstPg.dCnor") },
    { value: "cnee", label: t("bo.cusReqLstPg.dCnee") },
    { value: "trkNo", label: t("bo.cusReqLstPg.dTrkNo") },
    { value: "status", label: t("bo.cusReqLstPg.dSts") }
  ];
  const navigate = useNavigate();
  const limit = DEFAULT_PAGE_SIZE;
  const { setLoadingScreen, setLastSeenObjFn } = useAuthContext();

  // const [pageNumber, setPageNumber] = useState(1);
  // const [view, setView] = useState('list');
  // const [searchKeyWord, setSearchKeyWord] = useState("");
  // const [searchWord, setSearchWord] = useState("");
  // const [searchType, setSearchType] = useState(ddArr[0].value);
  // const [searchKeyType, setSearchKeyType] = useState(ddArr[0].value);
  // const [order, setOrder] = useState('desc');

  const [searchParams, setSearchParams] = useSearchParams();
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const searchType = searchParams.get("st") || ddArr[0].value;
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
  const order = searchParams.get("order") || "desc";
  const view = searchParams.get("view") || "list";

  const [searchKeyWord, setSearchKeyWord] = useState(searchWord);
  const [searchKeyType, setSearchKeyType] = useState(searchType);
  const [isFilterMdlOpen, setIsFilterMdlOpen] = useState(false);
  // Default the date filter to the last 1 month so old data isn't loaded up front.
  const [filterObj, setFilterObj] = useState(() => {
    const to = new Date();
    const from = new Date();
    from.setMonth(from.getMonth() - 1);
    return {
      fromDate: datePickerformat(from), toDate: datePickerformat(to),
      cnorNames: [], cneeNames: [], picLocations: [], delLocations: [], shipmtStatuses: [],
    };
  });

  const { isLoading, isError, error, data: custReqRow } = useQuery(
    [QueryKey.custReqList, pgNo, isSrchBtnClick, order, time, filterObj],
    async () => {
      // Server-side date filtering + pagination (stops loading old/all data).
      let res = await getAllCustReqWPagSrch({
        pageNumber: pgNo, limit, searchKeyWord: searchKeyWord, searchType: searchKeyType, order, time,
        fromDate: filterObj.fromDate, toDate: filterObj.toDate,
        cnorNames: filterObj.cnorNames, cneeNames: filterObj.cneeNames,
        picLocations: filterObj.picLocations, delLocations: filterObj.delLocations,
        shipmtStatuses: filterObj.shipmtStatuses,
      })
      return res;
    }, {
    keepPreviousData: true
  });

  const { data: custReqCfgArr } = useQuery([QueryKey.reportConfigList, "custReq"], () => getAllReportConfigs("custReq"));

  const columns = [
    {
      id: 'custReqId',
      label: t("bo.custRqTable.reqId"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'name',
      label: t("bo.custRqTable.cust"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'location',
      label: t("bo.custRqTable.fromTo"),
      align: 'left',
      minWidth: 190
    },
    {
      id: 'load',
      label: t("bo.custRqTable.matTyWeight"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'loadType',
      label: t("bo.custRqTable.loadType"),
      minWidth: 80
    },
    {
      id: 'preTruckTypes',
      label: t("bo.custRqTable.trkType"),
      align: 'left',
      minWidth: 190
    },
    time === 'history' && {
      id: 'shipCreated',
      label: t("bo.custRqTable.shipmtCreated"),
      // align: 'right',
      minWidth: 50
    },
    {
      id: 'c_at',
      label: t("bo.custRqTable.postedOn"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'options',
      label: '',
      // align: 'right',
      minWidth: 50
    },

  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Combined shipment creation: multi-select requests (current list only).
  const [selectedReqIds, setSelectedReqIds] = useState([]);
  const pageReqIds = (custReqRow?.data || []).map((r) => r.custReqId);

  function toggleReqSelect(custReqId) {
    setSelectedReqIds((prev) =>
      prev.includes(custReqId) ? prev.filter((id) => id !== custReqId) : [...prev, custReqId]);
  }

  function toggleReqSelectAll() {
    setSelectedReqIds((prev) => prev.length === pageReqIds.length ? [] : pageReqIds);
  }

  function handleCombShipmt() {
    navigate(route.boAddCombShipmt + "?custReqIds=" + selectedReqIds.join(","));
  }

  // SA-configured column set for Customer Request exports (falls back to the on-screen columns).
  const exportColumns = custReqCfgArr?.[0]?.config ? JSON.parse(custReqCfgArr[0].config) : columns;

  const optionItems = [
    {
      title: t("bo.reptListPg.pdf"),
      icon: <PictureAsPdf fontSize="small" />,
      fn: async () => {
        setLoadingScreen(true);
        try {
          const filterObj = {
            user: 'bo',
            time: time,
            reqType: "cust",
            ...(searchKeyWord && { searchKeyWord }),
            ...(searchType && { searchType: searchKeyType }),
            order
          }
          const res = await genCustReqRept({ filterObj, columns: exportColumns });
          window.open(res.fileUrl, "_blank")
        } catch (err) {
          // console.log(err);
          customAlert(err)
        }
        setLoadingScreen(false);
      }
    },
    {
      title: t("bo.reptListPg.excel"),
      icon: <Description fontSize="small" />,
      fn: async () => {
        try {
          const filterObj = {
            user: 'bo',
            time: time,
            reqType: "cust",
            ...(searchKeyWord && { searchKeyWord }),
            ...(searchType && { searchType: searchKeyType }),
            order
          }
          const res = await custReqExel({ filterObj, columns: exportColumns });
          window.open(res.fileUrl, "_blank")
        } catch (err) {
          // console.log(err);
          customAlert(err)
        }
      }
    }
  ]

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };


  function onViewChange(e, v) {
    if (v == null)
      return

    setSearchParams(prev => {
      prev.set("view", 1)
      return prev
    }, { replace: true })
  }

  async function onOrderChange(e, or) {
    if (or == null)
      return
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("order", or)
      return prev
    }, { replace: true })
  }

  useEffect(() => {
    if (time === "current") {
      setLastSeenObjFn('request');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  const handlePageChange = async (event, value) => {
    //    setPageNumber(value);
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };


  async function onSearchBtnClick(e) {
    setSearchKeyWord(searchWord);
    setSearchKeyType(searchType);
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setFilterObj({ fromDate: "", toDate: "", cnorNames: [], cneeNames: [], picLocations: [], delLocations: [], shipmtStatuses: [] })
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", encodeURIComponent(e.target.value))
      return prev
    }, { replace: true })
  }

  function handleDDChange(e) {
    setSearchParams(prev => {
      prev.set("st", e.target.value)
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchKeyWord("")
    setFilterObj({
      fromDate: '',
      toDate: '',
      cnorNames: [], cneeNames: [], picLocations: [], delLocations: [], shipmtStatuses: []
    })
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }

  function getSrchTypeTxt() {
    let filteredObj = ddArr.filter((i) => i.value === searchType);
    return filteredObj[0]?.label || "";
  }

  function handleTrkOp() {
    navigate(route.boTrkOpReqList + time)
  }

  async function handleAddReq() {
    navigate(route.boAddCustReq);
  }

  function handleFilterObj(obj) {
    setFilterObj((prev) => ({ ...prev, ...obj }));
    setSearchKeyWord("");
    setSearchKeyType("");
    setSearchWord("");
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  if (isLoading)
    return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>

  if (time !== "current" && time !== "history") {
    return <MissingPage />
  }

  return (
    <Box height={"100%"} width={"100%"}>
      <Stack direction={'row'} justifyContent='space-between' mb={1.5} >
        <Typography variant='h5' sx={{ fontWeight: "bold" }}>{time === "current" ? t("bo.cusReqLstPg.reqLstScrn") : t("bo.cusReqLstPg.reqHis")}<RecordCount count={custReqRow?.totalLength} /></Typography>
        <Stack mr={5}>
          <Stack direction={'row'} mx={1} gap={2}>
            <ButtonBase component="div">  <Typography sx={{ fontWeight: "600", color: "primary.main" }}>{t("bo.cusReqLstPg.cust")}</Typography></ButtonBase>
            <ButtonBase component="div" onClick={handleTrkOp}> <Typography sx={{ fontWeight: "600", }}>{t("bo.cusReqLstPg.trkOp")}</Typography></ButtonBase>
          </Stack>
          <Box sx={{ width: 228, backgroundColor: "#E3E3E3", borderRadius: 10, height: 5, mt: 0.5 }}>
            <Stack direction={'row'} height={4}>
              <Box sx={{ width: 88, backgroundColor: "primary.main", borderRadius: 10 }} />
              <Box sx={{ width: 140, borderRadius: 10 }} />
            </Stack>
          </Box>
        </Stack>
      </Stack>

      <BgBox height={"95%"} px={4} py={1}>
        <Stack direction={'row'} justifyContent="space-between" alignItems={"center"} mb={1.2} mt={0.4} px={2}>
          <StyledToggleButtonGroup color="primary" size="small" value={view} exclusive onChange={onViewChange} sx={{ mb: 0.5, height: 36 }}>
            <ToggleButton value='list'>
              <FormatListBulleted /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.cusReqLstPg.list")}</Typography>
            </ToggleButton>
            <ToggleButton value="center">
              <GridViewRounded /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.cusReqLstPg.grid")}</Typography>
            </ToggleButton>
          </StyledToggleButtonGroup>

          <Stack direction={'row'} justifyContent="space-between" alignItems={"center"}>
            <Box mb={0.5}><SearchTxtFieldClr handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`${t("bo.cusReqLstPg.search")} ${getSrchTypeTxt()} .....`} /></Box>
            <CustomDropDown height={36} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={searchType} />

            <StyledToggleButtonGroup color="primary" size="small" value={order} exclusive onChange={onOrderChange} sx={{ mb: 0.5, height: 36, mx: 3 }}>
              <ToggleButton value='desc'>
                <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDown /></Stack>
              </ToggleButton>
              <ToggleButton value="asc">
                <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDownAlt /></Stack>
              </ToggleButton>
            </StyledToggleButtonGroup>

            <Button variant='outlined' sx={{ ml: 2, mb: 0.5, height: 36, }} startIcon={<FilterAlt />} onClick={() => setIsFilterMdlOpen(true)} >Filter</Button>
            {time === 'current' && view === 'list' &&
              <Button variant='contained' sx={{ ml: 2, height: 36, mb: 0.5 }} color='secondary' disabled={selectedReqIds.length === 0} onClick={handleCombShipmt}>
                {t("bo.cusReqLstPg.createShipmt")}{selectedReqIds.length > 0 ? ` (${selectedReqIds.length})` : ""}
              </Button>}
            <Button variant='contained' sx={{ ml: 2, height: 36, mb: 0.5 }} startIcon={<Add />} color='primary' onClick={handleAddReq}>{t("bo.cusReqLstPg.addReq")}</Button>
            <Button variant='contained' sx={{ ml: 2, mb: 0.4 }} endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />} color='primary' onClick={handleExportClick} >{t("bo.reptListPg.export")}</Button>
          </Stack>
        </Stack>

        {view === 'list' ? <CustReqTable custReqRow={custReqRow?.data} time={time} columns={columns}
          selectable={time === 'current'} selectedIds={selectedReqIds} onToggleSelect={toggleReqSelect} onToggleAll={toggleReqSelectAll} /> :
          <ScrollBox height={"84%"}>
            <Grid container spacing={1}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              {custReqRow?.data.map((i) => <Grid item xs="auto" key={i.id}> <CustReqCard i={i} /> </Grid>)}
            </Grid>
          </ScrollBox>
        }

        <Stack sx={{ alignItems: "center", mt: 1 }}>
          <Pagination count={Math.ceil(custReqRow?.totalLength / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
        </Stack>

      </BgBox>
      <OptionMenu open={open} handleClose={handleExportClose} anchorEl={anchorEl} >
        {optionItems.map((i) => <MenuItem sx={{ pl: 2, pr: 5 }} key={i.title} onClick={i.fn}>
          <ListItemIcon > {i.icon}</ListItemIcon>
          {i.title}
        </MenuItem>)}
      </OptionMenu>
      <FilterMdl modalOpen={isFilterMdlOpen} handleModalClose={() => setIsFilterMdlOpen(false)} filterObj={filterObj} handleFilterObj={handleFilterObj} />
    </Box>
  )
}

export default CustReqListPage;